import { Component, OnInit, Input, AfterViewInit, OnDestroy } from '@angular/core';
import * as _ from 'underscore';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { CONSTANTS, EVENT_EMITTERS, COLORS } from '../../../analytics/constants/analytics.constants';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { ColorConfig, DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';

@Component({
	selector: 'app-social-demographics-r2',
	templateUrl: './social-demographics-r2.component.html',
	styleUrls: ['./social-demographics-r2.component.css']
})
export class SocialDemographicsR2Component implements OnInit, AfterViewInit, OnDestroy {
	@Input() sectiontitle: string;
	@Input() key: string;
	@Input() downloadconfig: string;
	@Input() legend: any;
	@Input() sectionclass: string;
	public downloadConfiguration: DownloadConfig;

	public responseData: {};
	public overallTotal = 0;
	public finalData = {};
	public ageArray = [];
	public reloadSubscription;
	public showLoad = true;
	public colorPalette: ColorPalette;
	public hasData = true;
	public widgetDataSubscription;
	public colorPalatte: ColorPalette;
	objectKeys = Object.keys;
	public femaleState = true;
	public maleState = true;
	public unknownState = true;
	public activeIndex = 0;
	public selectedMetric: string;
	public newChartArrData = [];
	public chartConfigObj = {
		svgHeight: 200,
		svgWidth: 190,
		seriesName: '',
		xLegendPos: 0,
		yLegendPos: 0,
		innerSize: '100',
		tooltipColor: '#FFF',
		tooltipTextColor: '#FFF',
		tooltipFontSize: '13px',
		followPointer: true,
		showPercentageToolTip: false,
		addSeriesNameToLables: true,
		size: 200,
		verticalAlign: 'middle',
		legendText: '',
		datalabelsEnabled: false,
		dataLabelsDistance: 5,
		lineBreak: undefined,
		isTooltipEnabled: true,
		margin: [20, 20, 20, 20],
		type: 'pieDonut',
		legendItemDistance: 100,
		enableCustomLegend: true,
		customLegendData: undefined
	};

	constructor(
		private analyticsService: AnalyticsService,
		private analyticsDataModel: AnalyticsDataModel,
		private colorUtilityService: ColorUtilityService
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit() {
		this.legend = JSON.parse(decodeURI(this.legend));
		this.selectedMetric = this.legend[0].value;
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
	}

	ngAfterViewInit() {
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.requestData();
	}

	setMetricData(metric, index) {
		this.selectedMetric = metric;
		this.activeIndex = index;
		this.newChartArrData = [];
		this.ageArray = [];
		this.processResponseData(this.responseData);
	}

	requestData() {
		this.showLoad = true;
		this.hasData = true;
		this.newChartArrData = [];
		this.ageArray = [];
		this.widgetDataSubscription = this.analyticsService
			.processCustomServiceRequest(this.key)
			.subscribe((response: any) => {
				this.showLoad = false;
				if (response.success && response.data.length > 0) {
					this.hasData = true;
					this.responseData = response.data;
					this.processResponseData(response.data);
				} else {
					this.hasData = false;
				}
			});
	}

	selectedMetricData(data, demographicAgeGroup) {
		for (const ageGroup in demographicAgeGroup) {
			data[ageGroup] = _.groupBy(demographicAgeGroup[ageGroup], 'gender');
			for (const row in data[ageGroup]) {
				let sumOfMetric = _.pluck(data[ageGroup][row], this.selectedMetric).reduce(function (
					accumulator,
					currentValue
				) {
					return Number(accumulator) + Number(currentValue);
				});
				data[ageGroup][row] = sumOfMetric;
			}
		}
		this.generateChartData(data);
	}
	generateChartData(data) {
		const self = this;
		this.newChartArrData = [];
		this.objectKeys(data)
			.sort()
			.forEach(function (ageGroup) {
				let index = 1;
				let graphData = [];
				let total = 0;
				let that = self;
				self
					.objectKeys(data[ageGroup])
					.sort()
					.forEach((gender, index) => {
						let yValue = 0;
						if (that.femaleState && gender === 'female') {
							yValue = data[ageGroup][gender];
						}
						if (that.maleState && gender === 'male') {
							yValue = data[ageGroup][gender];
						}
						if (that.unknownState && gender === 'unknown') {
							yValue = data[ageGroup][gender];
						}
						total += Number(yValue);
						let obj = {
							name: that.selectedMetric,
							y: Number(yValue),
							color: that.colorUtilityService.getRGBByColorType(
								that.colorPalette,
								index == 0 ? COLORS.PRIMARY : index === 1 ? COLORS.SECONDARY : COLORS.TERTIARY,
								1
							)
						};
						graphData.push(obj);
					});
				self.newChartArrData.push([
					{
						type: 'pie',
						size: '100%',
						innerSize: '60%',
						name: 'Impressions',
						data: graphData
					}
				]);
				self.ageArray.push({
					total: total,
					ageGroup: ageGroup
				});
			});
		this.overallTotal = _.pluck(self.ageArray, 'total').reduce(function (accumulator, currentValue) {
			return Number(accumulator) + Number(currentValue);
		});
	}
	processResponseData(response) {
		let data = {};
		const demographicAgeGroup = _.groupBy(response, 'age_group');
		this.selectedMetricData(data, demographicAgeGroup);
	}
	updateChartData(legend) {
		if (legend === 'female') {
			this.femaleState = !this.femaleState;
		}
		if (legend === 'male') {
			this.maleState = !this.maleState;
		}
		if (legend === 'unknown') {
			this.unknownState = !this.unknownState;
		}
		this.newChartArrData = [];
		this.ageArray = [];
		this.processResponseData(this.responseData);
	}

	ngOnDestroy() {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	downloadCSV(e) {
		e.preventDefault();
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName
		);
	}
}
